export class Environment {
  readonly production!: boolean;
  readonly mockDomaine!: string;
  readonly baseUrlSpa!: string;
  readonly mouvementEndpoint!: string;
  readonly mock!: boolean;
  readonly keyPosteCanada!: string;
  readonly identifiantProjetPosteCanada!: string;
  readonly spinnerTimeout!: number;
  readonly requestTimeout!: number;
}
